/**
 * Dissolvenza background configurations
 * These backgrounds are suitable for memorial headshots
 */
export const DISSOLVENZA_BACKGROUNDS = [
  // Gradient backgrounds - soft pastel colors for memorial photos
  {
    id: 'celeste',
    name: 'Celeste Chiaro',
    key: 'GRADIENT_LIGHTBLUE',
    preview: '#E6F3FF',
    type: 'gradient',
  },
  {
    id: 'pesca',
    name: 'Pesca Delicato',
    key: 'GRADIENT_PEACH',
    preview: '#FFF0E6',
    type: 'gradient',
  },
  {
    id: 'gradient_lavender',
    name: 'Lavanda Pallida',
    key: 'GRADIENT_LAVENDER',
    preview: '#F3E6FF',
    type: 'gradient',
  },
  {
    id: 'gradient_rose',
    name: 'Rosa Cipria',
    key: 'GRADIENT_ROSE',
    preview: '#FFE6F0',
    type: 'gradient',
  },
  {
    id: 'gradient_mint',
    name: 'Menta Leggera',
    key: 'GRADIENT_MINT',
    preview: '#E6FFF0',
    type: 'gradient',
  },
  {
    id: 'gradient_pearl',
    name: 'Grigio Perla',
    key: 'GRADIENT_PEARL',
    preview: '#F5F5F5',
    type: 'gradient',
  },
  {
    id: 'gradient_cream',
    name: 'Crema',
    key: 'GRADIENT_CREAM',
    preview: '#FFF9F0',
    type: 'gradient',
  },
  {
    id: 'gradient_sage',
    name: 'Salvia Chiara',
    key: 'GRADIENT_SAGE',
    preview: '#F0F5E6',
    type: 'gradient',
  },
  // Naturalistic backgrounds
  {
    id: 'luce_divina',
    name: 'Luce Divina',
    key: 'LUCE_DIVINA',
    preview: '/assets/sidebar/ai/dissolvenza/paesaggi/luce_divina.jpg',
    type: 'nature',
  },
  {
    id: 'celetste',
    name: 'Luce Celeste',
    key: 'CELESTE',
    preview: '/assets/sidebar/ai/dissolvenza/paesaggi/celeste.jpg',
    type: 'nature',
  },
  {
    id: 'bosco',
    name: 'Bosco',
    key: 'BOSCO',
    preview: '/assets/sidebar/ai/dissolvenza/paesaggi/bosco.jpg',
    type: 'nature',
  },
  {
    id: 'cielo',
    name: 'Cielo',
    key: 'CIELO',
    preview: '/assets/sidebar/ai/dissolvenza/paesaggi/sky.jpg',
    type: 'nature',
  },
  {
    id: 'montagne',
    name: 'Montagne',
    key: 'MONTAGNE',
    preview: '/assets/sidebar/ai/dissolvenza/paesaggi/montagne.jpg',
    type: 'nature',
  },
  {
    id: 'farfalle',
    name: 'Farfalle',
    key: 'FARFALLE',
    preview: '/assets/sidebar/ai/dissolvenza/paesaggi/farfalle.jpg',
    type: 'nature',
  },
  {
    id: 'autunno',
    name: 'Autunno',
    key: 'AUTUNNO',
    preview: '/assets/sidebar/ai/dissolvenza/paesaggi/autunno.jpg',
    type: 'nature',
  },
  {
    id: 'notte',
    name: 'Notte',
    key: 'NOTTE',
    preview: '/assets/sidebar/ai/dissolvenza/paesaggi/notte.jpg',
    type: 'nature',
  },
  {
    id: 'tramonto',
    name: 'Cielo al Tramonto',
    key: 'TRAMONTO',
    preview: '/assets/sidebar/ai/dissolvenza/paesaggi/tramonto.jpg',
    type: 'nature',
  },
  {
    id: 'fiori_di_ciliegio',
    name: 'Fiori di Ciliegio',
    key: 'FIORI_DI_CILIEGIO',
    preview: '/assets/sidebar/ai/dissolvenza/paesaggi/fiori_di_ciliegio.jpg',
    type: 'nature',
  },
  {
    id: 'mare',
    name: 'Mare',
    key: 'MARE',
    preview: '/assets/sidebar/ai/dissolvenza/paesaggi/mare.jpg',
    type: 'nature',
  },
  {
    id: 'faro',
    name: 'Faro',
    key: 'FARO',
    preview: '/assets/sidebar/ai/dissolvenza/paesaggi/faro.jpg',
    type: 'nature',
  },
];
